var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex h-full flex-column",
      class: !_vm.isMobileAndTablet ? "justify-center" : "",
      attrs: { id: "start_message_block" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column justify-center align-center" },
        [
          _c("asset-image", {
            attrs: {
              src: require("../../images/ai_navigator/ai_navigator_icon.svg"),
              width: "64",
            },
          }),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "text-h5 text--primary text-center mt-2 mb-3" },
            [_vm._v("Ask code questions with AI Navigator")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "chat-message",
        { staticClass: "mb-1", attrs: { type: "system" } },
        [
          _c("p", [
            _vm._v(
              "\n            Got a code question? Just ask. I'm here to help you figure it out – no jargon, no hassle. Ask\n            anything, and I'll do my best to get you what you need.\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "font-weight-bold mb-2" },
            [
              _vm.isRecentAskedQuestionsAvailable
                ? [_vm._v("\n                Recently Asked\n            ")]
                : [
                    _vm._v(
                      "\n                Not sure where to start? Try one of these questions:\n            "
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.loadingQuestion
            ? _c("v-progress-linear", {
                staticStyle: { "min-width": "10em" },
                attrs: { active: true, color: "primary", indeterminate: "" },
              })
            : _vm._l(_vm.questions, function (question, key) {
                return _c("p", { key: key, staticClass: "mb-2" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.questionClicked(question)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.isRecentAskedQuestionsAvailable
                              ? question.question
                              : question
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ])
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }